import { createElement, type ComponentProps } from "react";
import { createNavigation } from "next-intl/navigation";
import { crossAppLinkProps } from "@/lib/crossAppLinks";
import { routing } from "./routing";

const navigation = createNavigation(routing);
export const { redirect, usePathname, useRouter } = navigation;

/** Keep locale-aware routing and native new-tab behavior in one place. */
export function Link(props: ComponentProps<typeof navigation.Link>) {
  const href = typeof props.href === "string" ? props.href : props.href.pathname || "";
  return createElement(navigation.Link, { ...props, ...crossAppLinkProps(href, props.locale) });
}
